module.exports = __webpack_public_path__ + "img/flower_leaf_36.89e95c01.png";